/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {AccidentClassification} from "../model/AccidentClassification";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class AccidentClassificationService {


  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/accidentclassifications';
  }


  getAll(): Observable<AccidentClassification[]> {
    const url = `${this.baseUrl}/all`;
    return this.http.get(url, httpOptions).pipe(
      map(AccidentClassifications => AccidentClassifications as AccidentClassification[]));
  }

  updateAccidentClassificationById(accidentClassification: AccidentClassification): Observable<AccidentClassification>{
    const id = accidentClassification.accidentClassificationId;
    const url = `${this.baseUrl}/${id}`;

    return this.http.put(url,accidentClassification,httpOptions).pipe(
      map(accidentClassification => accidentClassification as AccidentClassification));
  }

  addAccidentClassification(accidentClassification: AccidentClassification): Observable<AccidentClassification>{
    const url = `${this.baseUrl}`;

    return this.http.post(url,accidentClassification,httpOptions).pipe(
      map(accidentClassification => accidentClassification as AccidentClassification));
  }
}

